import { Button, radius } from "@libertify/ui";
import { StopIcon } from "@phosphor-icons/react";
import { Flex, Typography, Space, Progress } from "antd";
import { EllipsisAnimated } from "components/EllipsisAnimated/EllipsisAnimated/";
import { formatTime, MAX_SAMPLE_DURATION } from "../hooks/useVoiceCloning";
import { useTranslate } from "@refinedev/core";
import { useAntTheme } from "hooks/useAntTheme/";

export const VoiceRecording = ({
  stopRecord,
  recordingDuration,
}: {
  stopRecord: () => void;
  recordingDuration: number;
}) => {
  const t = useTranslate();
  const { theme } = useAntTheme();
  return (
    <Flex vertical gap={0}>
      <Flex justify="space-between">
        {/* Red dot indicator */}
        <Space>
          <span
            style={{
              display: "inline-block",
              width: "10px",
              height: "10px",
              backgroundColor: "red",
              borderRadius: radius.circle,
            }}
          />
          <Typography.Text>
            {t("media.components.VoiceProfileCreateForm.recording")}
            <EllipsisAnimated />
          </Typography.Text>
        </Space>
        <Button
          variant="tertiary"
          size="s"
          shape="round"
          style={{ alignItems: "center", display: "flex" }}
          icon={<StopIcon weight="fill" size={"1em"} />}
          onClick={stopRecord}
        >
          {t("media.components.VoiceProfileCreateForm.stop")}
        </Button>
      </Flex>
      <Flex vertical>
        <Space>
          <Typography.Text style={{ fontSize: 12 }}>
            {formatTime(recordingDuration)}
          </Typography.Text>
          <Typography.Text type="secondary" style={{ fontSize: 12 }}>
            / {formatTime(MAX_SAMPLE_DURATION)}
          </Typography.Text>
        </Space>
        <Progress
          percent={(recordingDuration / MAX_SAMPLE_DURATION) * 100}
          showInfo={false}
          strokeColor={{
            "0%": theme.colorPrimary,
            "100%": theme.colorPrimary,
          }}
        />
      </Flex>
    </Flex>
  );
};
